import './assets/styles3.css';const n = "_tableContainer_1mwmj_1", t = "_toolbar_1mwmj_12", o = "_tableScrollContainer_1mwmj_23", a = "_table_1mwmj_1", e = "_emptyState_1mwmj_65", _ = "_tableHeader_1mwmj_74", m = "_cell_1mwmj_81", i = "_column_1mwmj_54", c = "_columnResizer_1mwmj_124", l = "_sortIndicator_1mwmj_129", r = "_columnHeader_1mwmj_142", s = "_row_1mwmj_179", w = "_pagination_1mwmj_309", g = "_paginationLoading_1mwmj_324", j = "_paginationContent_1mwmj_335", p = "_paginationRange_1mwmj_343", b = {
  tableContainer: n,
  toolbar: t,
  tableScrollContainer: o,
  table: a,
  emptyState: e,
  tableHeader: _,
  cell: m,
  column: i,
  columnResizer: c,
  sortIndicator: l,
  columnHeader: r,
  row: s,
  pagination: w,
  paginationLoading: g,
  paginationContent: j,
  paginationRange: p
};
export {
  b as c
};
